<template>
    <v-dialog
    v-model="openModal"
    max-width="500px">
        <v-card>
            <div class="modal-header">
                <h4 class="modal-headline">{{ $page.props.lang.addCustomField || "Add custom field" }}</h4>
                <div class="tools">
                    <v-btn icon @click="$emit('close')"><v-icon>mdi-close</v-icon></v-btn>
                </div>
            </div>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col v-if="$vuetify.breakpoint.xs" cols="7">
                           <p class="custom-label">{{ $page.props.lang.measurement_label || 'Label' }}</p>
                            <v-text-field v-model="newCustom.label"
                            outlined dense
                            :error-messages="responseErrors.label" @focus="responseErrors.label=''"></v-text-field>
                        </v-col>
                        <v-col v-else cols="5">
                           <p class="custom-label">{{ $page.props.lang.measurement_label || 'Label' }}</p>
                            <v-text-field v-model="newCustom.label"
                            outlined dense
                            :error-messages="responseErrors.label" @focus="responseErrors.label=''"></v-text-field>
                        </v-col>
                        <v-col v-if="$vuetify.breakpoint.xs" cols="5">
                            <p class="custom-label">{{ $page.props.lang.measurement_unit_edit || 'Type' }}</p>
                            <v-text-field v-model="newCustom.type"
                            outlined dense
                            :error-messages="responseErrors.type" @focus="responseErrors.type=''"></v-text-field>
                        </v-col>
                        <v-col v-else cols="4">
                            <p class="custom-label">{{ $page.props.lang.measurement_unit || 'Type' }}</p>
                            <v-text-field v-model="newCustom.type"
                            outlined dense
                            :error-messages="responseErrors.type" @focus="responseErrors.type=''"></v-text-field>
                        </v-col>
                        <v-col v-if="!$vuetify.breakpoint.xs" cols="3">
                            <v-tooltip bottom open-delay="500">
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn style="margin-top:23px; margin-left:10px" depressed color="primary" @click="add" v-bind="attrs" v-on="on">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                            </template>
                            <span>{{$page.props.lang.save || "Save"}}</span>
                            </v-tooltip>   
                        </v-col>
                        <div style="margin-left: 7rem;" v-else>
                        <v-tooltip bottom open-delay="500">
                            <template v-slot:activator="{ on, attrs }">
                            <v-btn style="margin-top:23px; margin-left:10px" depressed color="primary" @click="add" v-bind="attrs" v-on="on">
                                <v-icon>mdi-check</v-icon>
                            </v-btn>
                            </template>
                            <span>{{$page.props.lang.save || "Save"}}</span>
                            </v-tooltip>   
                        </div>
                    </v-row>    
                    
                        <div style="margin-top: 30px">
                            <v-data-table
                                :headers="headers"
                                :items="customs"
                                item-key="item.id"
                                :items-per-page="5"
                                mobile-breakpoint="0"
                                hide-default-footer>
                                <template v-slot:item.label="{ item }">
                                        {{ item.label }} 
                                </template>
                                <template v-slot:item.type="{ item }">
                                        {{ item.type }} 
                                </template>
                                <template v-slot:item.action="{ item, index }">
                                    <v-btn @click="openEditModal(item, index)" :id="'edit' + item.id" icon>
                                        <v-icon color="#616161">mdi-pencil</v-icon>
                                        <v-tooltip :activator="'#edit'+ item.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.edit || "Edit"}}</span>
                                        </v-tooltip>
                                    </v-btn>
                                    <v-btn @click="openDeleteModal(item.id, index)" :id="'delete' + item.id" icon>
                                        <v-icon color="#FF0000">mdi-delete</v-icon>
                                        <v-tooltip :activator="'#delete'+ item.id" bottom open-delay="500">
                                            <span>{{$page.props.lang.delete || "Delete"}}</span>
                                        </v-tooltip>
                                    </v-btn>
                                </template>
                            </v-data-table>
                            <ConfirmModal 
                                    :title="$page.props.lang.confirmModalTitle || 'Confirmation'" 
                                    :description="$page.props.lang.delete_custom_confirmation_description || 'If you click YES, the custom field will be permanently deleted. Are you sure?'" 
                                    :open="deleteModal" 
                                    @no="deleteModal = false" 
                                    @yes="deleteCustom()" 
                                    @close="deleteModal = false">
                            </ConfirmModal>
                        </div>
                </v-container>
            </v-card-text>
        </v-card>
        <v-dialog v-model="editModal" max-width="500px" style="max-height:150px; overflow:hidden;">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editCustom || "Edit custom field" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col v-if="!$vuetify.breakpoint.xs" cols="5">
                                <p class="custom-label">{{ $page.props.lang.measurement_label || 'Label' }}</p>
                                <v-text-field v-model="selectedCustom.label"
                                outlined dense
                                :error-messages="responseErrors.label" @focus="responseErrors.label=''"></v-text-field>
                            </v-col>
                            <v-col v-else cols="6">
                                <p class="custom-label">{{ $page.props.lang.measurement_label || 'Label' }}</p>
                                <v-text-field v-model="selectedCustom.label"
                                outlined dense
                                :error-messages="responseErrors.label" @focus="responseErrors.label=''"></v-text-field>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xs" cols="3">
                            <p class="custom-label">{{ $page.props.lang.measurement_unit_edit || 'Type' }}</p>
                            <v-text-field v-model="selectedCustom.type"
                            outlined dense
                            :error-messages="responseErrors.type" @focus="responseErrors.type=''"></v-text-field>
                            </v-col>
                            <v-col v-else cols="6">
                            <p class="custom-label">{{ $page.props.lang.measurement_unit_edit || 'Type' }}</p>
                            <v-text-field v-model="selectedCustom.type"
                            outlined dense
                            :error-messages="responseErrors.type" @focus="responseErrors.type=''"></v-text-field>
                            </v-col>
                            <v-col v-if="!$vuetify.breakpoint.xs" cols="4">
                                <v-btn style="margin-top:23px; margin-left:15px" @click="edit()" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                            </v-col>
                            <v-card-actions v-else style="margin-top: 0px">
                            <v-spacer></v-spacer>
                            <v-btn @click="edit()" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                        </v-row>
                        
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>

<script>
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'
export default {
    name: "CustomsModal",
    components: {
        ConfirmModal
    },
    props: {
        customs: Array,
        modal: Boolean,
        lang: Object
    },
    data() {
        return {
            customsData:this.customs,
            sub: null,
            newCustom: {},
            show:false,
            headers:[
                 {text: this.$page.props.lang.measurement_label || 'Label', value: 'label', sortable: false, align: 'start'},
                 {text: this.$page.props.lang.measurement_unit || 'Unit', value: 'type', sortable: false, align:'center'},
                 {text: '', value: 'action', sortable: false, align:'right'},
            ],
            responseErrors:{},
            customToDeleteId: null,
            deleteModal: false,
            customToEditId: null,
            editModal: false,
            selectedCustom:{},
            customToDeleteIndex: null,
            customToEditIndex: null
        }
    },
    computed: {
        openModal: {
            get: function() {
                return this.modal
            },
            set: function() {
                this.$emit('close')
                return false
            }
        }
    },
        methods: {
            add() {
                 this.responseErrors = {}
            axios.post('/backoffice/members/saveCustomMeasurement', this.newCustom)
                .then(response => {
                    if (response.data.status==="OK") {
                        this.newCustom = {};

                    }
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: response.data.message,
                        color: 'success',
                        timeout: 5000
                    })
                    EventBus.$emit('CUSTOM_MEASUREMENT_ADDED', response.data.data );
                })
                .catch(error => {
                    EventBus.$emit('SHOW_NOTIFICATION', {
                        message: error.response.data.message,
                        color: 'error',
                        timeout: 10000
                    })
                    this.responseErrors = error.response.data.errors
                })
            },

            openEditModal(item, index){
                this.customToEditIndex = index
                axios.get('/backoffice/members/getCustomMeasurement/'+ item.id)
                    .then(response => {
                        if(response.data.status === "OK"){
                            this.selectedCustom = response.data.custom
                            this.editModal = true
                        }else{
                            alert(response.data.message)
                        }
                        
                    })
            },

            edit(){
                this.responseErrors = {}
                axios.post('/backoffice/members/editCustom', this.selectedCustom)
                    .then(response => {
                    if (response.data.status==="OK") {
                        this.editModal = false

                        EventBus.$emit('CUSTOM_MEASUREMENT_UPDATED', {
                            index: this.customToEditIndex,
                            custom: this.selectedCustom 
                        })

                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                        this.$inertia.reload({only:['customs']})
                    }
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
            },

            openDeleteModal(id, index){
                this.customToDeleteId = id;
                this.customToDeleteIndex = index;
                this.deleteModal = true;
            },

            deleteCustom(){
                 axios.post('/backoffice/members/deleteCustomMeasurement', {id: this.customToDeleteId})
                .then(response => {
                    if (response.data.status==="OK") {
                       EventBus.$emit('CUSTOM_MEASUREMENT_DELETED', {
                           index: this.customToDeleteIndex
                     })
                    }
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: 'success',
                                timeout: 5000
                            })
                })
                .catch(error => {                   
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                    this.responseErrors = error.response.data.errors
                })
                this.deleteModal = false
            }
        }
}
</script>